import { Link } from "react-router-dom";
import Banner from "@/components/ui/banner/Banner";

type ProjectVideo = {
	id: string;
	title: string;
};

const Videos: ProjectVideo[] = [
	{ id: "sp8s4SRq8jk", title: "■ 01 瀏覽商品" },
	{ id: "twTUNKeCQdE", title: "■ 02 商品詳情" },
	{ id: "G6Kd6PuE0AE", title: "■ 03 購物車" },
	{ id: "M8WFxcvcYfA", title: "■ 04 結帳 - 選擇超商取貨" },
	{ id: "aBWYuFUkdg4", title: "■ 05 結帳 - 信用卡付款" },
	{ id: "rcdUG5Q7mU8", title: "■ 06 付款成功 - 訂單結果" },
	{ id: "xonVBxJ_kvM", title: "■ 07 商品資料快取" },
];

const ProjectPage = () => {
	return (
		<div className="flex flex-col">
			<Banner
				banner={{
					image: {
						default: "/images/banner-shopping-info.jpg",
						desktop: "/images/banner-shopping-info.jpg",
					},
					title: "專案介紹",
				}}
				heightClasses="h-24 lg:h-48"
				skeletonSize="sm"
			/>

			<section className="mx-auto w-full max-w-6xl px-4 py-10 lg:py-14">
				<h2 className="brand-heading-md text-brand-black text-center">流程展示</h2>
				<p className="lg:text-md mb-6 mt-3 max-w-xs pr-8 text-center text-sm lg:max-w-lg leading-relaxed text-base-content m-auto">
					從「商品瀏覽」到「完成付款」，完整展示購物流程。
				</p>

				<div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
					{Videos.map((video) => (
						<article key={video.id} className=" rounded-md  overflow-hidden ">
							<div className="aspect-[16/10] w-full bg-base-200 shadow-md">
								<iframe
									className="h-full w-full"
									src={`https://www.youtube-nocookie.com/embed/${video.id}?modestbranding=1&rel=0`}
									title={video.title}
									loading="lazy"
									frameBorder={0}
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									referrerPolicy="strict-origin-when-cross-origin"
									allowFullScreen
								/>
							</div>
							<div className="py-2">
								<h3 className="brand-text-md line-clamp-1 text-brand-black">{video.title}</h3>
							</div>
						</article>
					))}
				</div>
			</section>

			<section className="mx-auto w-full max-w-6xl px-4 pb-16 mt-8">
				<div className="flex items-center justify-center">
					<Link to="/" className="brand-btn-base btn-primary btn" >
						逛逛網站
					</Link>
				</div>
			</section>
		</div>
	);
};

export default ProjectPage;